if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
    }
   
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {

            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            console_log(response);
            this.cartNotification.renderContents(response);

            document.body.dispatchEvent(new CustomEvent('product-added-to-cart', { 'detail': response }));
            
            if (response.product_type != 'synbiotic' 
              && response.product_type != 'dailybacs' 
              && response.product_type != 'dietbacs' 
              &&  response.product_type != 'dermabacs' 
              &&  response.product_type != 'bundle' 
              &&  response.product_type != 'Shakes') {
              console_log('addon')
              document.body.dispatchEvent(new CustomEvent('addon-added-to-cart', { detail: response }));
              
            }

            if (location.href.indexOf('/cart') > -1) {
              if (response.properties?._swapped_with) {
                this.removeItemFromCart(response.properties._swapped_with);
              }else {
                document.body.dispatchEvent(new CustomEvent('can-check-mov', { detail: response }));
              }
            }
          

            let items = [];

            //Gifts
            if (response.properties._gifts != undefined) {
              let gifts =  response.properties._gifts.split(',');
              
              gifts.forEach(gift => {
                items.push({
                  "id": gift,
                  "quantity": 1,
                  "properties": {
                    "_boughtWith": response.handle,
                    "_key": response.key,
                    "_type": "gift"
                  }
                });
              });

            }

            //Welcome Kits
            if (response.properties._welcome_kit != undefined) {
              let welcome_jars = response.properties._welcome_kit.split(',');
              let multiplier = 1;
          
              for (let i = 0; i < welcome_jars.length; i++) { 
                if (welcome_jars[i].length > 0) {
          
                  if (welcome_jars[i] == welcome_jars[i + 1]) {
                    multiplier += 1;
                    continue;
                  }
          
                  items.push({
                    "id": welcome_jars[i],
                    "quantity": multiplier,
                    "properties": {
                      "_boughtWith": response.handle,
                      "_key": response.key,
                      "_multiplier": multiplier,
                      "_type": "welcome-jar"
                    }
                  });
                }
              }
            } 

            let itemFormData = new FormData();
            items.forEach((item, index) => {
              itemFormData.append(`items[${index}][id]`, item.id);
              itemFormData.append(`items[${index}][quantity]`, item.quantity);
              itemFormData.append(`items[${index}]properties[_boughtWith]`, item.properties._boughtWith);
              itemFormData.append(`items[${index}]properties[_key]`, item.properties._key);
              itemFormData.append(`items[${index}]properties[_multiplier]`, item.properties._multiplier);
              itemFormData.append(`items[${index}]properties[_type]`, item.properties._type);
            });
            
            itemFormData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
            itemFormData.append("sections_url", `${window.location.pathname}`);
            config.body = itemFormData;

            if (items.length > 0) {
              this.ajaxAddToCart(config);
            } 
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    removeItemFromCart(id) {
      const body = JSON.stringify({
        id: id,
        quantity: 0
      });

      console_log('remove from cart')

      fetch(`${routes.cart_change_url}`,  { ...fetchConfig(), ...{ body }})
      .then(response => response)
      .then(data => {
        console_log(data);
        document.body.dispatchEvent(new CustomEvent('can-check-mov', { detail: data }));
      })
      .catch(err => console_log(err));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    ajaxAddToCart = (config) => {
      let cart_link = document.getElementById('cart-notification-button') || false;
      cart_link && cart_link.classList.add('disabled');
    
      fetch(`${routes.cart_add_url}`, config).then(function (response) {
        return response.json();
      }).then(function (response) {
        document.querySelector('cart-notification').renderContents(response);
      }).catch(function (err) {
        console.error(err);
      }).finally(() => {
        cart_link && cart_link.classList.remove('disabled')
      });
    }

    parseSections = sectionsToRender => {
      fetch(window.location.pathname + `?sections=${sectionsToRender}`)
      .then(res => res.json())
      .then(data => {
        console_log(data)
      });
    }

  });
}

const getCart = async () => {
  return await fetch(`/cart.json`)
    .then(response => {
      return response.json();
    })
    .then(data => {
      return data;
    })
    .catch(err => {
      console.error(err);
    });
}